import {
    Routes,
    Route,
} from "react-router-dom";
import ChargeDisputesPage from "./charge-disputes/charge-disputes-page.component";
import ChargeDisputesRoutes from "./charge-disputes/charge-disputes.routes";



export default function RefundsRoutes() {
    return (
        <Routes>
            <Route path="/" element={<ChargeDisputesPage />} />
            <Route path="/charge-disputes/*" element={<ChargeDisputesRoutes />} />
        </Routes>
    )
}